<template>
    <div>
      <StackedHorizontalBarChart
        :title=chartTitle
        :filterContext="filterContext"
        :dataProviders="dataProviders"
        :contextUpdaters="contextUpdaters"
        :navigationConfig="navigationConfig"
        :chartFontColor="chartFontColor"
        chartCardHeight="940"
        @updateFilter="handleFilterUpdate"
      />
    </div>
  </template>
  
<script setup>
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import StackedHorizontalBarChart from '@/components/charts/base/StackedHorizontalBarChart.vue';

  
  const store = useStore();
  const { t } = useI18n();
  const filterContext = computed(() => store.state.filterItemsContext);
  const chartFontColor = computed(() => store.getters.chartFontColor);
  const conn = store.getters.getDBConnection;

  const chartName = 'teamUserStackedBarChart';
  const chartTitle = t('teamAndUserBreakdown');

  const selectedTeamId = ref(null);
  const singleUserId = ref(null);
  

/*const getTeamProfiles = async (filtered = true) => {
  const table = filtered ? 'filteredItems' : 'items';
  const query = `
    WITH items_with_team_profile AS (
        SELECT 
            COALESCE(t.teamProfileId, 'unassigned') AS id,
            COALESCE(t.teamProfileTitle, 'Un-assigned') AS title,
            s.title AS status_title,
            s.color as color,
            s.sort
        FROM ${table} i
        JOIN status_templates s ON i.StatusId = s.id
        LEFT JOIN teams t ON i.AssigneeTeamId = t.id
    )

    SELECT 
        id,
        title,
        status_title,
        color,
        COUNT(*) AS value,
        MIN(sort) AS sort
    FROM items_with_team_profile
    GROUP BY id, title, status_title, color
    ORDER BY title, sort, status_title
  `;
  
  return executeAndProcessQuery(query);
};*/

const getTeams = async (filtered = true) => {
  const table = filtered ? 'filteredItems' : 'items';
  const query = `
    SELECT 
        COALESCE(t.id, 'unassigned') AS id,
        COALESCE(t.name, 'Un-assigned') AS title,
        s.title as status_title,
        s.color as color,
        COUNT(*) AS value,
        MIN(s.sort) AS sort
    FROM ${table} i
    JOIN status_templates s ON i.StatusId = s.id
    LEFT JOIN teams t ON i.AssigneeTeamId = t.id
    GROUP BY COALESCE(t.id, 'unassigned'), COALESCE(t.name, 'Un-assigned'), s.title, s.color
    ORDER BY COALESCE(t.name, 'Un-assigned'), sort, status_title
  `;
  
  return executeAndProcessQuery(query);
};
   
const getUsers = async (filtered = true) => {
  const table = filtered ? 'filteredItems' : 'items';
  const query = `
        SELECT 
        COALESCE(u.id, 'unassigned') AS id,
        COALESCE(u.displayName, 'Un-assigned') AS title,
        s.title as status_title,
        s.color as color,
        COUNT(*) AS value,
        MIN(s.sort) AS sort
    FROM ${table} i
    JOIN status_templates s ON i.StatusId = s.id
    LEFT JOIN users u ON array_contains(i.AssigneeUserIds, u.id)
    GROUP BY COALESCE(u.id, 'unassigned'), COALESCE(u.displayName, 'Un-assigned'), s.title, s.color
    ORDER BY COALESCE(u.displayName, 'Un-assigned'), sort, status_title
  `;
  
  return executeAndProcessQuery(query);
};

const getSingleUser = async (filtered = true) => {
  const table = filtered ? 'filteredItems' : 'items';
  const query = `
        SELECT 
        COALESCE(u.id, 'unassigned') AS id,
        COALESCE(u.displayName, 'Un-assigned') AS title,
        s.title as status_title,
        s.color as color,
        COUNT(*) AS value,
        MIN(s.sort) AS sort
    FROM ${table} i
    JOIN status_templates s ON i.StatusId = s.id
    LEFT JOIN users u ON array_contains(i.AssigneeUserIds, u.id)
    ${ singleUserId.value == 'unassigned' ? '' : 'WHERE array_contains(i.AssigneeUserIds, CAST(' + singleUserId.value + ' AS VARCHAR))'}
    GROUP BY COALESCE(u.id, 'unassigned'), COALESCE(u.displayName, 'Un-assigned'), s.title, s.color
    ORDER BY COALESCE(u.displayName, 'Un-assigned'), sort, status_title
  `;
  
  return executeAndProcessQuery(query);
};


/*const getTeamProfileFilterContext = async (teamProfileId) => {

  if (teamProfileId == 'unassigned') {
    const query = `
      SELECT DISTINCT i.SubItemId
      FROM items i
      Where i.AssigneeTeamId = ''
    `;
    await updateFilteredItemsContext(query);

  } else {
    const query = `
      SELECT DISTINCT i.SubItemId
      FROM items i
      JOIN teams t ON i.AssigneeTeamId = t.id
      WHERE t.teamProfileId = '${teamProfileId}'
    `;
    await updateFilteredItemsContext(query);
  }
};*/

const getTeamFilterContext = async (teamId) => {
  selectedTeamId.value = teamId;

  if (teamId == 'unassigned') {

    const query = `
      SELECT DISTINCT i.SubItemId
      FROM items i
      Where i.AssigneeTeamId = ''
    `;
    await updateFilteredItemsContext(query);

  } else {
    const query = `
      SELECT DISTINCT i.SubItemId
      FROM items i
      WHERE i.AssigneeTeamId = '${teamId}'
    `;
    await updateFilteredItemsContext(query);
  }
};

const getUserFilterContext = async (userId) => {
  singleUserId.value = userId;
  if (userId == 'unassigned') {

    const query = `
      SELECT DISTINCT i.SubItemId
      FROM items i
      WHERE i.AssigneeTeamId = '${selectedTeamId.value === 'unassigned' ? '' : selectedTeamId.value}' AND array_length(i.AssigneeUserIds) = 0
    `;
    await updateFilteredItemsContext(query);

  } else {
    const query = `
      SELECT DISTINCT i.SubItemId
      FROM items i
      WHERE i.AssigneeTeamId = '${selectedTeamId.value}' AND array_contains(i.AssigneeUserIds, '${userId}')
    `;
    await updateFilteredItemsContext(query);
  }
  
};


const resetFilterContext = async () => {
    singleUserId.value = null;
    selectedTeamId.value = null;
    await filterContext.value.removeFilter(chartName);
}

  const dataProviders = {
    //teamprofiles: getTeamProfiles,
    teams: getTeams,
    users: getUsers,
    singleuser: getSingleUser
  };
  
  const contextUpdaters = {
    //teamprofiles: getTeamProfileFilterContext,
    teams: getTeamFilterContext,
    users: getUserFilterContext,
    singleuser: getUserFilterContext,
    reset: resetFilterContext /*required*/
  };
  
  const navigationConfig = [
    //{ level: 'teamprofiles', titleKey: t('teamProfile') },
    { level: 'teams', titleKey: 'teams' },
    { level: 'users', titleKey: 'users' },
    { level: 'singleuser', titleKey: 'singleuser' }
  ];


  const updateFilteredItemsContext = async (query) => {
    await filterContext.value.updateFilterWithQuery(chartName, query);
  };

  // Shared data processing utility function
const processChartData = (rows) => {
  const groupedData = {};
  
  rows.forEach(row => {
    const id = row['id'];
    const title = row['title'];
    const parentId = row['parentId'] ? row['parentId'] : null;
    const type = row['type'] ? row['type'] : null
    
    if (!groupedData[id]) {
      groupedData[id] = {
        name: title,
        id: id,
        parentId: parentId,
        type: type,
        children: []
      };
    }
    
    // Find if this color already exists in the children
    const existingColor = groupedData[id].children.find(
      child => child.color === row.color
    );
    
    if (existingColor) {
      existingColor.value += row.value;
      // Store the status names by color
      if (!existingColor.statusCounts) {
        existingColor.statusCounts = {};
      }
      existingColor.statusCounts[row.status_title] = row.value;
    } else {
      groupedData[id].children.push({
        color: row.color,
        value: row.value,
        statusName: row.status_title,
        sort: row.sort,
        statusCounts: { [row.status_title]: row.value }
      });
    }
  });
  
  return Object.values(groupedData).map(item => ({
    ...item,
    children: item.children.sort((a, b) => a.sort - b.sort)
  }));
};

// Generic query execution function
const executeAndProcessQuery = async (query, idField, titleField) => {
  const result = await conn.query(query);
  const rows = result.toArray().map((row) => {
    const jsonRow = row.toJSON();
    return {
      ...jsonRow,
      value: Number(jsonRow.value)
    };
  });
  
  return processChartData(rows, idField, titleField);
};

  </script>